import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { INACTIVE_PROSPECTING, readProspectingAvailability } from './rolloutAvailability';

/** Session-scoped and deduplicated. Loading has the deployed, inactive UI.
 * Refetch on focus so a refreshed team sees a separately approved activation. */
export function useProspectingAvailability() {
  const { client, access } = useAuth();
  const actor = access?.status === 'approved' ? access.profile.id : null;
  const query = useQuery({
    queryKey: ['prospecting-availability', actor],
    enabled: actor !== null,
    queryFn: () => readProspectingAvailability(client),
    staleTime: 30_000,
    retry: false,
  });
  return actor === null ? INACTIVE_PROSPECTING : (query.data ?? INACTIVE_PROSPECTING);
}
